import React from "react";
import "./Sidebar.css";
import { Link, useNavigate } from "react-router-dom";
import { UserRound, UserRoundCheck } from "lucide-react";

import TravelAgency from "../../assets/travel-agency.svg";
import Home from "../../assets/home.svg";
import EmAndamento from "../../assets/em-andamento.svg";
import Cancel from "../../assets/cancel.svg";

const SidebarTraveler = ({ menuOpen, setMenuOpen }) => {
  const navigate = useNavigate();
  const handleCloseMenu = () => setMenuOpen(false);

  return (
    <>
      <div
        className={`mobile-overlay ${menuOpen ? "show" : ""}`}
        onClick={handleCloseMenu}
      />

      <aside className={`sidebar ${menuOpen ? "open" : "closed"}`}>
        <button
          className="desktop-toggle"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          {menuOpen ? "❮" : "❯"}
        </button>

        <nav>
          <ul>
            <li
              className="active"
              onClick={() => {
                handleCloseMenu();
                navigate("/dashboard-traveler");
              }}
            >
              <img src={Home} className="sidebar-icon" alt="" />
              Início
            </li>

            <li
              onClick={() => {
                handleCloseMenu();
                navigate("/trips-progress-traveler");
              }}
            >
              <img src={EmAndamento} className="sidebar-icon" alt="" />
              Viagens em andamento
            </li>

            <li
              onClick={() => {
                handleCloseMenu();
                navigate("/trips-concluded-traveler");
              }}
            >
              <img src={TravelAgency} className="sidebar-icon" alt="" />
              Viagens Realizadas
            </li>

            <li onClick={handleCloseMenu}>
              <img src={Cancel} className="sidebar-icon" alt="" />
              Viagens não efetivadas
            </li>

            <div className="sidebar-section-title">PAINEIS DE CONTROLE</div>

            <li
              className="special-panel panell"
              onClick={() => {
                handleCloseMenu();
                navigate("/dashboard-client");
              }}
            >
              <UserRound size={40} strokeWidth={2.5} className="tag-icon" />
              <div className="panel-text">
                <strong>Painel do Cliente</strong>
              </div>
            </li>

            <li
              className="special-panel panell"
              onClick={() => {
                handleCloseMenu();
                navigate("/dashboard-receiver");
              }}
            >
              <UserRoundCheck
                size={50}
                strokeWidth={2.5}
                className="tag-icon"
              />
              <div className="panel-text">
                <strong>Painel do Destinatário</strong>
              </div>
            </li>
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default SidebarTraveler;
